import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {OwsClientService, ServiceEndpoint} from 'ows-library';
import {LocalStorageService} from 'angular-2-local-storage';
import {Subject} from 'rxjs';
import {RequestsService} from './requests.service';
import {environment} from '../../../environments/environment';
import {AppConfigService} from '../../app-config.service';
import {AppConfigService2} from '../../../app-config.service';


@Injectable()
export class AutenticacaoService {
  sessionChanged = new Subject<number>();
  loginChanged = new Subject<boolean>();

  /*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
    Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(private owsClientService: OwsClientService,
              private route: Router,
              private requestsService: RequestsService,
              private internalStorage: LocalStorageService,
              private service: AppConfigService,
              private appConfig: AppConfigService2) {
  }

  prepareEndPoint() {
    this.owsClientService.service = this.appConfig.service;
    this.owsClientService.application = this.appConfig.application;
    this.owsClientService.applicationName = this.appConfig.applicationName;
    this.owsClientService.applicationVersion = this.appConfig.applicationVersion;

    if (this.owsClientService.serviceEndpointCollection.count() === 0) {
      const serviceEndpoint = new ServiceEndpoint();
      serviceEndpoint.protocol = this.appConfig.protocol;
      serviceEndpoint.region = this.appConfig.region;
      serviceEndpoint.domain = this.appConfig.domain;
      this.owsClientService.serviceEndpointCollection.add(serviceEndpoint);

      this.owsClientService.serviceEndpointCollection.setRandomOrder();
    }
  }

  atualizarSessao() {
    this.sessionChanged.next(this.appConfig.sessaoTimeOut);
  }
}
